import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import getMiddlewareSocketInstance from './common/SocketMiddleware';
import api from './api';

const apiCaller = getApiInstance();

function initEnvironment() {
    return (dispatch, getState) => {
        return apiCaller
            .call(api.initEnvironment())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'MYFHE_GIT__SET_GROUPID',
                        groupId: data.groupId
                    });
                    dispatch({
                        type: 'MYFHE_GIT__SET_ASSIGNEEIDS',
                        assigneeIds: data.assigneeIds
                    });

                    let access_token = localStorage.getItem('access_token');
                    if (access_token) access_token = access_token.replace(/"/g, '');

                    /** Middleware Connection **/
                    if (typeof data.middlewaresConfig !== 'undefined') {
                        getMiddlewareSocketInstance(dispatch, getState, access_token, data.middlewaresConfig);
                    }
                }
                if (data.users) {
                    dispatch({
                        type: 'MYFHE__SET_USERS',
                        users: data.users
                    });
                } else throw 'general.error.data_has_not_correctly_returned_by_server';

                return data;
            })
            .catch(error => {
                Logger.error('dataActions: initEnvironmentMyFHE - ', error);
                throw error;
            });
    };
}

function disconnectEnvironment() {
    return dispatch => {
        const middlewareInstance = getMiddlewareSocketInstance();
        if (middlewareInstance) middlewareInstance.destroy();
        dispatch({
            type: 'RESET_STORE'
        });
    };
}

export { initEnvironment, disconnectEnvironment };



// WEBPACK FOOTER //
// ./environments/myfhe/actions.js